define('gigaset_recurring/classes/provider/billwerk/loader',[
	"jquery",
	"lodash",
	"lucid",
	"cartware/components/Config"
], function(
	$,
	_,
	lucidJS,
	Config
) {

	function Loader() {
		lucidJS.EventEmitter.call(this);
		this.url = Config.get('recurring.provider.billwerk.js');
	}

	Loader.prototype = _.create(new lucidJS.EventEmitter, {
		constructor: Loader,

		loaded: false,
		url: null,

		load: function() {
			if (this.loaded) return this;

			var backupGlobals = ["baseUrl", "Portal", "Signup", "Payment", "validateVatId", "finalize", "selfServiceSettings"],
				backup = {};

			_.forEach(backupGlobals, function(variable) {
				backup[variable] = window[variable];
			});

			require([this.url], _.bind(function() {
				var BillwerkJs = {};

				_.forEach(backupGlobals, function(variable) {
					BillwerkJs[variable] = window[variable];
					window[variable] = backup[variable];
				});

				window.BillwerkJS = BillwerkJs;
				window.baseUrl = BillwerkJs.baseUrl; // BillwerkJS.Payment depends on this being globally set

				this.flag("loaded");
			}, this));

			return this;
		}
	});

	return (new Loader);

});
